import React, { useContext } from 'react'
import { Tooltip, Typography } from 'antd';
import LanguageSelector from './../language/LanguageSelector'
import { appContext } from "./../../AppContext";
import {
    Mobile,
    DefaultDevice
} from './../../Utils/mediaQuery'

const { Text } = Typography;

export default function LoginFooter() {
    const [appState] = useContext(appContext);
    return (
        <>
            <DefaultDevice>
                <>
                    <footer className="login-footer">
                        <Tooltip trigger="click" title={"Identity Manager v." + appState.version}>
                            <Text type="secondary">© 2020 Prequest. All Rights reserved.</Text>
                        </Tooltip>
                        <LanguageSelector />
                    </footer>
                </>
            </DefaultDevice>

            <Mobile>
                <>
                    <footer className="login-footer">
                        <Tooltip trigger="click" title={"Identity Manager v." + appState.version}>
                            <Text type="secondary">© 2020 Prequest. All Rights reserved.</Text>
                        </Tooltip>
                    </footer>
                </>
            </Mobile>
        </>
    )
}